import { FC, ReactElement } from 'react';
import { H3, P } from '@ahmdigital/ui';
import { isString, map } from 'lodash/fp';

import { OptionBox, OptionButton, OptionButtonRow, OptionContainer, OptionContentRow } from './styles';
import type { ContactProps } from '../types';

export type ContactOptionProps = Omit<ContactProps, 'subText'> & {
  buttonNoWrap?: boolean;
  buttonOnClick?: () => void;
  isButtonDisabled?: boolean;
  isHighlighted?: boolean;
  subText: (string | ReactElement)[];
};

const ContactOption: FC<ContactOptionProps> = ({
  buttonNoWrap = false,
  buttonOnClick,
  buttonText,
  buttonUrl,
  isButtonDisabled = false,
  subText,
  title,
  isHighlighted = false,
}) => (
  <OptionContainer>
    <OptionBox data-testid="optionBox" isHighlighted={isHighlighted}>
      <OptionContentRow variant="paddingBottomSpacer9">
        <H3 looksLike="h4" variant={['marginBottomSpacer11']}>
          {title}
        </H3>
        {map(
          (text) => (
            <P variant={['small14', 'withoutMargin']} key={isString(text) ? text : text.key}>
              {text}
            </P>
          ),
          subText,
        )}
      </OptionContentRow>
      <OptionButtonRow>
        {(buttonUrl || buttonOnClick) && buttonText && (
          <OptionButton $noWrap={buttonNoWrap} onClick={buttonOnClick} to={buttonUrl} disabled={isButtonDisabled}>
            {buttonText}
          </OptionButton>
        )}
      </OptionButtonRow>
    </OptionBox>
  </OptionContainer>
);

export default ContactOption;
